module.exports = __webpack_public_path__ + "img/CT.Bridges.Substructure.Solid_Wall_Pier.Reinforced_Concrete.0c279196.png";